import React, { useContext } from 'react';
import { Button } from '@material-ui/core';
import { SocketContext } from '../Context';

const Notifications = () => {
  const { answerCall, call, callAccepted,declineCall } = useContext(SocketContext);


  return (
    <>
      {call.isReceivingCall && !callAccepted && (
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <h4>{call.name} is calling:</h4>
          <Button variant="contained" color="primary" onClick={answerCall}>
            Answer
          </Button>
          <Button variant="contained" color="secondary" onClick={declineCall}>
            Decline
          </Button>
        </div>
      )}
    </>
  ); 
};

export default Notifications;
